var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "数量限制" } },
        [
          _c("el-input-number", {
            staticClass: "max-fill",
            attrs: {
              "controls-position": "right",
              precision: 0,
              min: 1,
              max: 6,
              size: "small",
              placeholder: "最多上传几张图片",
            },
            model: {
              value: _vm.value.maxNumber,
              callback: function ($$v) {
                _vm.$set(_vm.value, "maxNumber", $$v)
              },
              expression: "value.maxNumber",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }